import React, { useContext, useState, useEffect } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import Copy from '../Common/Copy';
import Swal from 'sweetalert2';
import axios from 'axios';
import Web3 from 'web3';
import { Link } from 'react-router-dom';
import Pagination from '../Common/Pagination';


export default function PrimeReward() {
    const { togel, setTogel, formatAddress, isSidebarEnabled, setIsSidebarEnabled, formatDateTime } = useContext(GMCContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pages, setPages] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [selected_Status, setSelected_Status] = useState([]);
    const [selected_address, setselected_address] = useState([]);
    const [selected_rank, setselected_rank] = useState([]);
    const [selected_Msg, setselected_Msg] = useState([]);


    const onCheckboxChange = (e, rank, username, status) => {
        e.preventDefault(); // prevent auto toggle

        Swal.fire({
            title: 'Confirm Prime Reward',
            html: `Are you sure you want to process a confirm PrimeReward for <strong>${username}</strong> ?`,
            icon: 'warning',
            html: `
            <p>Are you sure you want to process a confirm PrimeReward for <strong>${username}</strong> ?</p>
            <textarea id="remarks" class="swal2-textarea" placeholder="Enter Admin Message"></textarea>
        `,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, proceed!',
            cancelButtonText: 'Cancel',
            preConfirm: () => {
                const remarks = document.getElementById('remarks').value;
                if (!remarks) {
                    Swal.showValidationMessage('Message is required'); // ✅ shows red error message
                    return false;
                }
                return { remarks }; // pass textarea value
            }
        }).then((result) => {
            // console.log('result.isConfirmed', result.isConfirmed);

            if (result.isConfirmed) {
                handleWithdrawalStatusChange(result.isConfirmed, e, rank, username, result.value.remarks, status);
            }
        });
    };


    const handleWithdrawalStatusChange = async (isChecked, event, rank, username, msg, status) => {
        // const isChecked = event?.target?.checked;
        // console.log('event',event?.target?.checked);

        // console.log('Event triggered with values:',  username, rank,msg,status);
        // setWithdrawalStatus(true)

        // Convert to Wei
        // const amtInWei = Web3?.utils?.toWei(amount?.toString() || "0", "ether");
        // console.log("Amount in Wei (18 decimals):", amtInWei);

        // console.log('ischecked', (isChecked));
        if (isChecked) {

            // Store updated state locally to use in axios
            const updatedAddress = [...selected_address, username];
            const updatedRank = [...selected_rank, rank];
            const updatedMsg = [...selected_Msg, msg];
            const updatedStatus = [...selected_Status, status];

            // Update states
            setselected_address(updatedAddress);
            setselected_rank(updatedRank);
            setselected_Msg(updatedMsg);
            setSelected_Status(updatedStatus);

            // Send data to backend using freshly computed values
            try {
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "admin",
                    submethod: "updateprime",
                    key: process.env.REACT_APP_KEY,
                    username: username,
                    rankname: rank,
                    msg: msg,
                    status: true,
                    // total: updatedValue,
                });
                // setTimeout(() => {
                //  setWithdrawalStatus(false)
                // }, 1000);
                if (res.data.error) return;
                getData()

                console.log("POST request successful");
                setselected_address([]);
                setselected_rank([]);
                setselected_Msg([]);
                setSelected_Status([])

            } catch (err) {
                console.error("Error sending prime reward confirmation data:", err);
            }

        } else {
            // Find index to remove
            const index = selected_address.findIndex(item => item === username);
            // console.log('index', index);

            if (index !== -1) {
                const updatedAddress = selected_address.filter((_, i) => i !== index);
                const updatedRank = selected_rank.filter((_, i) => i !== index);
                const updatedMsg = selected_Msg.filter((_, i) => i !== index);
                const updatedStatus = selected_Status.filter((_, i) => i !== index);
                // const updatedValue = value - parseFloat(amount);

                // Update states
                setselected_address(updatedAddress);
                setselected_rank(updatedRank);
                setselected_Msg(updatedMsg);
                setSelected_Status(updatedStatus);
            }
        }
    };


    // Fetch data function
    const getData = async () => {
        try {
            setLoading(true);
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "prime",
                submethod: "get",
                key: process.env.REACT_APP_KEY,
                search: search,
                page: currentPage,
                pageSize: pageSize,

            });

            setLoading(false);
            if (res.data.error) return;
            console.log('res prime inc', res.data.data)
            setData(res.data.data);
            setPages(Math.ceil(res.data.dataLength / pageSize));
        } catch (err) {
            console.log("Error : ", err);
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, [pageSize, currentPage, search]);

    useEffect(() => {
        if (currentPage > pages) {
            setCurrentPage(1); // Reset to page 1 if currentPage is out of range
        }
    }, [pages]);


    return (
        <>
            <Header />
            <Sidebar />
            <div id="layout-wrapper">
                <div className="vertical-overlay" onClick={() => setIsSidebarEnabled((prev) => !prev)} />
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* Page Title Section */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                            <li className="breadcrumb-item active">Prime Reward</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                            {/* Member Report Table Section */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title mb-0">Prime Reward</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="listjs-table" id="customerList">
                                                {/* Table Action Buttons */}
                                                <div className="row g-4 mb-3">
                                                    <div className="col-sm-auto">
                                                    </div>
                                                    <div className="col-sm">
                                                        <div className="d-flex justify-content-sm-end">
                                                            <div className="search-box ms-2">
                                                                <input
                                                                    type="text"
                                                                    className="form-control search"
                                                                    placeholder="Search..."
                                                                    onChange={(e) => setSearch(e.target.value)}
                                                                />
                                                                <i className="ri-search-line search-icon" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Table */}
                                                <div className="table-responsive table-card mt-3 mb-1">
                                                    <table className="table align-middle table-nowrap" id="customerTable">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className="gridjs-th text-center">#</th>
                                                                <th className="gridjs-th text-center">User Name</th>
                                                                <th className="gridjs-th text-center">Rank</th>
                                                                <th className="gridjs-th text-center">Admin Message</th>
                                                                <th className="gridjs-th text-center">Date</th>
                                                                <th className="gridjs-th text-center">Confirmation</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data.length > 0 ? (
                                                                data.map((ele, i) => {
                                                                    console.log("LOG",ele?.checkStatus,);
                                                                    
                                                                    const index = currentPage * pageSize - pageSize + (i + 1);
                                                                    const statusForRank = ele?.checkStatus?.data?.find(
                                                                        (r) => r?.rankid === ele?.rankid
                                                                    );

                                                                    console.log('statusForRank',statusForRank);

                                                                    return (
                                                                        <tr key={i}>
                                                                            <td className="gridjs-td text-center"> {index}</td>
                                                                            <td className="gridjs-td text-center" >
                                                                                <a
                                                                                    target="_blank"
                                                                                    className="text-primary"
                                                                                    href={`${process.env.REACT_APP_EXPLORER}/address/${ele.username}`}
                                                                                    rel="noreferrer"
                                                                                >
                                                                                    {(ele.username)}
                                                                                </a>
                                                                                <Copy data={ele.username} /> {/* Use the Copy component */}
                                                                            </td>
                                                                            <td className="gridjs-td text-center" >
                                                                                <strong>Rank</strong><br />
                                                                                {ele.rank || "-"} <br />
                                                                                <br /><strong>Reward</strong> <br />
                                                                                {ele.reward ? ele.reward : "-"}
                                                                            </td>
                                                                            <td className="gridjs-td text-center" >{ele.adminMsg ? ele.adminMsg : "--"}</td>
                                                                            <td className="gridjs-td text-center" >
                                                                                <strong>Achieve Date</strong><br />
                                                                                {formatDateTime(ele.date)} <br />
                                                                                <br /><strong>Approve Date</strong><br />
                                                                                {ele.approveDate ? formatDateTime(ele.approveDate) : '--'}
                                                                            </td>
                                                                            <td className='gridjs-td text-center' >
                                                                                <label className={`custom-checkbox`}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={ele.status}
                                                                                        disabled={
                                                                                            ele.status === true ||
                                                                                            statusForRank?.allow === false
                                                                                        }
                                                                                        title={
                                                                                            ele.status === true
                                                                                                ? "Already approved"
                                                                                                : statusForRank?.allow === true
                                                                                                    ? "Eligible to approve"
                                                                                                    : "Timeline Over"
                                                                                        }
                                                                                        onChange={(e) =>
                                                                                            onCheckboxChange(e, ele.rank, ele.username, ele.status)
                                                                                        }
                                                                                    />
                                                                                    {
                                                                                        ele.status === true ? (
                                                                                            // Already approved → GREEN
                                                                                            <i className="bi bi-check-circle-fill text-success"></i>

                                                                                        ) : statusForRank?.allow === true ? (
                                                                                            // primeId matches rankid → RED
                                                                                            <i className="bi bi-check-circle-fill text-secondary"></i>

                                                                                        ) : (
                                                                                            // Not approved & not matched → GREY
                                                                                            <i className="bi bi-check-circle-fill text-danger"></i>
                                                                                        )
                                                                                    }

                                                                                </label>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="11" className="text-center">
                                                                        No data available
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                    <style>
                                                        {`
                                                        
                                                            .custom-checkbox {
                                                                position: relative;
                                                                display: inline-flex;
                                                                align-items: center;
                                                                cursor: pointer;
                                                            }

                                                            .custom-checkbox input[type="checkbox"] {
                                                                opacity: 0;
                                                                position: absolute;
                                                                width: 0;
                                                                height: 0;
                                                            }

                                                            .custom-checkbox.checked {
                                                                background: green; /* ✅ green when true */
                                                                color: white;
                                                                border-radius: 30%;
                                                            }

                                                            .custom-checkbox i {
                                                                font-size: 24px;
                                                                color: #ccc;
                                                                transition: color 0.3s;
                                                            }

                                                            /* Optional hover effect */
                                                            .custom-checkbox:hover i {
                                                                color: #405189;
                                                                content:'r';
                                                            }
                                                        `}
                                                    </style>
                                                </div>

                                                <Pagination
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    pages={pages}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}